export const PRODUCTS_TYPES_FORMATS = {
  LIST: '240x240',
  MOSAIC: '600x600',
  SEARCH: '240x240',
};

export const FOOTER_PROMOTION_BLOCK_FORMATS = {
  phone: '670x274',
  tablet: '648x266',
  desktop: '432x386',
  large: '448x400',
  full: '448x400',
};

export const LOGIN_PROMOTION_BLOCK_FORMATS = {
  phone: '670x556',
  tablet: '700x580',
  desktop: '700x580',
  large: '652x580',
  full: '652x580',
};

export const HOME_SLIDES_FORMATS = {
  phone: '670x700',
  tablet: '1376x600',
  desktop: '1252x546',
  large: '1744x760',
  full: '1744x760',
};

export const HOME_PROMOTION_BLOCK_FORMATS = {
  phone: '670x292',
  tablet: '1376x600',
  desktop: '614x546',
  large: '856x760',
  full: '856x760',
};

export const HOME_ECATALOGS_FORMATS = {
  phone: '320x450',
  tablet: '320x450',
  desktop: '320x450',
  large: '320x450',
  full: '320x450',
};

export const ECATALOGS_FORMATS = {
  phone: '294x414',
  tablet: '500x708',
  desktop: '500x708',
  large: '500x708',
  full: '500x708',
};

export const MENU_CATEGORIES_FORMAT = '60x60';
export const PRODUCT_REFERENCES_FORMAT = '74x74';
export const PRODUCT_BUNDLES_FORMAT = '120x120';
export const PRODUCT_BARCODE_FORMAT = '200x200';
